import React, { Component } from "react";
import {
  loading,
  NavbarCustomer,
  t
} from "../../components/CustomComponent.js"; // ปรับ Path ให้ตรงกับโปรเจกต์ของคุณ

export default class AppointmentList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_status: "All Appointments",
      active_view: "list", // 'list' or 'calendar'

      // Mock Data: Appointments (อิงตามรูป image_16445e.png)
      today: [
        {
          id: "WO-20250126-001",
          time: "10:00",
          ampm: "AM",
          title: "Chiller Unit #3 - Emergency Repair",
          location: "Building A, Floor 1",
          tech: "Somchai T.",
          duration: "2-3 hours",
          status: "In Progress",
          statusColor: "primary",
          checkIn: "Technician has checked in at 10:05 AM",
          accentColor: "#3b82f6"
        },
        {
          id: "WO-20250126-002",
          time: "14:00",
          ampm: "PM",
          title: "AHU Floor 5 - Filter Replacement",
          location: "Building B, Rooftop",
          tech: "Prasit K.",
          duration: "1-2 hours",
          status: "Scheduled",
          statusColor: "warning",
          checkIn: "Technician will arrive between 14:00 - 14:30",
          accentColor: "#f59e0b"
        }
      ],
      tomorrow: [
        {
          id: "WO-20250127-001",
          time: "09:00",
          ampm: "AM",
          title: "Generator #1 - PM Service",
          location: "Basement",
          tech: "To be assigned",
          duration: "3-4 hours",
          status: "Confirmed",
          statusColor: "secondary",
          checkIn: "Parts have been prepared for this service",
          accentColor: "#6c757d"
        }
      ],
      later: [
        { date: "Jan 28, 2025", time: "10:00 AM", title: "Quarterly PM Inspection", asset: "Chiller Unit #2", location: "Building A", status: "Confirmed", statusBg: "bg-light text-dark border" },
        { date: "Jan 30, 2025", time: "09:00 AM", title: "Annual Safety Inspection", asset: "Fire Pump System", location: "Building A", status: "Pending Confirmation", statusBg: "bg-warning-light text-warning" }
      ]
    };
  }

  async componentDidMount() {
    loading(false);
  }

  render() {
    const { today, tomorrow, later, filter_status, active_view } = this.state;

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarCustomer />
        <div className="body p-4 mt-3">
          
          {/* Header & View Switcher */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div className="btn-group bg-white p-1 rounded-3 shadow-sm border border-light">
              <button 
                className={`btn btn-sm px-3 rounded-2 fw-bold border-0 ${active_view === 'list' ? 'btn-primary' : 'btn-white text-secondary'}`}
                onClick={() => this.setState({ active_view: 'list' })}
              >
                <span className="icon me-1">{"\uf0ca"}</span> {t("list_view")}
              </button>
              <button 
                className={`btn btn-sm px-3 rounded-2 fw-bold border-0 ${active_view === 'calendar' ? 'btn-primary' : 'btn-white text-secondary'}`}
                onClick={() => this.setState({ active_view: 'calendar' })}
              >
                <span className="icon me-1">{"\uf073"}</span> {t("calendar_view")}
              </button>
            </div>

            <div className="d-flex align-items-center gap-2">
              <span className="text-secondary text-14">{t("filter")}:</span>
              <select 
                className="form-select wpx-180 rounded-3 border-light shadow-none bg-white fw-bold text-dark"
                value={filter_status}
                onChange={(e) => this.setState({ filter_status: e.target.value })}
              >
                <option>{t("all_appointments")}</option>
              </select>
            </div>
          </div>

          {/* Today Group */}
          <div className="mb-5">
            <h6 className="fw-bold text-dark mb-3 d-flex align-items-center">
              <span className="icon text-primary me-2">{"\uf133"}</span> {t("today")} - January 26, 2025
            </h6>
            <div className="d-flex flex-column gap-3">
              {today.map((item, idx) => (
                <div key={idx} className="card border-0 rounded-4 shadow-sm bg-white overflow-hidden">
                  <div className="d-flex border-start border-5" style={{ borderColor: item.accentColor }}>
                    <div className="p-4 text-center border-end border-light" style={{ width: '100px' }}>
                      <h4 className="fw-bold text-dark mb-0">{item.time}</h4>
                      <div className="text-secondary text-12 fw-bold">{item.ampm}</div>
                    </div>
                    <div className="p-4 flex-grow-1">
                      <div className="d-flex justify-content-between align-items-start mb-2">
                        <div>
                          <h5 className="fw-bold text-dark mb-1">{item.title}</h5>
                          <div className="text-secondary text-14">{item.location}</div>
                        </div>
                        <div className="text-end">
                          <span className={`badge bg-${item.statusColor}-light text-${item.statusColor} rounded-pill px-3 py-1 fw-bold text-10 border border-${item.statusColor} border-opacity-10 mb-1`}>
                            <span className="icon me-1">{item.status === 'Scheduled' ? "\uf017" : "\uf0ad"}</span> {item.status}
                          </span>
                          <div className="text-secondary text-10">{item.id}</div>
                        </div>
                      </div>
                      <div className="d-flex align-items-center gap-4 text-secondary text-13 mt-3">
                        <span><span className="icon me-1">{"\uf007"}</span> Technician: <strong>{item.tech}</strong></span>
                        <span><span className="icon me-1">{"\uf017"}</span> Est. Duration: <strong>{item.duration}</strong></span>
                      </div>
                      <hr className="text-light my-3" />
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="text-secondary text-12 d-flex align-items-center">
                          <span className="icon me-2">{"\uf05a"}</span> {item.checkIn}
                        </div>
                        <button className="btn btn-link text-primary text-decoration-none fw-bold p-0 text-13">
                          <span className="icon me-1">{"\uf06e"}</span> {t("view_details")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Tomorrow Group */}
          <div className="mb-5">
            <h6 className="fw-bold text-dark mb-3 d-flex align-items-center">
              <span className="icon text-secondary me-2">{"\uf073"}</span> {t("tomorrow")} - January 27, 2025
            </h6>
            {tomorrow.map((item, idx) => (
               <div key={idx} className="card border-0 rounded-4 shadow-sm bg-white overflow-hidden opacity-75">
                  <div className="d-flex border-start border-5 border-light">
                    <div className="p-4 text-center border-end border-light" style={{ width: '100px' }}>
                      <h4 className="fw-bold text-dark mb-0">{item.time}</h4>
                      <div className="text-secondary text-12 fw-bold">{item.ampm}</div>
                    </div>
                    <div className="p-4 flex-grow-1">
                      <div className="d-flex justify-content-between align-items-start">
                        <div>
                          <h5 className="fw-bold text-dark mb-1">{item.title}</h5>
                          <div className="text-secondary text-14">{item.location}</div>
                        </div>
                        <div className="text-end">
                          <span className="badge bg-light text-dark rounded-pill px-3 py-1 fw-bold text-10 border border-light mb-1">
                            <span className="icon me-1">{"\uf073"}</span> {item.status}
                          </span>
                          <div className="text-secondary text-10">{item.id}</div>
                        </div>
                      </div>
                      <div className="d-flex align-items-center gap-4 text-secondary text-13 mt-3">
                        <span><span className="icon me-1">{"\uf007"}</span> Technician: <strong>{item.tech}</strong></span>
                        <span><span className="icon me-1">{"\uf017"}</span> Est. Duration: <strong>{item.duration}</strong></span>
                      </div>
                      <hr className="text-light my-3" />
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="text-secondary text-12 d-flex align-items-center">
                          <span className="icon me-2">{"\uf0ad"}</span> {item.checkIn}
                        </div>
                        <button className="btn btn-link text-primary text-decoration-none fw-bold p-0 text-13">
                          <span className="icon me-1">{"\uf06e"}</span> {t("view_details")}
                        </button>
                      </div>
                    </div>
                  </div>
               </div>
            ))}
          </div>

          {/* Later Group Table */}
          <div className="mb-4">
            <h6 className="fw-bold text-dark mb-3 d-flex align-items-center">
              <span className="icon text-secondary me-2">{"\uf073"}</span> {t("later_this_week")}
            </h6>
            <div className="card border-0 rounded-4 shadow-sm bg-white overflow-hidden">
              <div className="table-responsive">
                <table className="table table-hover align-middle mb-0">
                  <thead className="bg-light">
                    <tr className="text-secondary fw-bold text-12 border-bottom border-light">
                      <th className="py-3 px-4 border-0">{t("date_time")}</th>
                      <th className="py-3 border-0">{t("service")}</th>
                      <th className="py-3 border-0">{t("asset")}</th>
                      <th className="py-3 border-0 text-center">{t("status")}</th>
                      <th className="py-3 border-0 text-center">{t("actions")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {later.map((item, idx) => (
                      <tr key={idx} className="border-bottom border-light">
                        <td className="py-4 px-4">
                          <div className="fw-bold text-dark text-14">{item.date}</div>
                          <div className="text-secondary text-12">{item.time}</div>
                        </td>
                        <td><div className="text-dark text-14">{item.title}</div></td>
                        <td>
                          <div className="text-dark text-14 fw-bold">{item.asset}</div>
                          <div className="text-secondary text-12">{item.location}</div>
                        </td>
                        <td className="text-center">
                          <span className={`badge rounded-pill px-3 py-1 fw-bold text-10 ${item.statusBg}`}>
                            {item.status}
                          </span>
                        </td>
                        <td className="text-center">
                          <button className="btn btn-link text-primary text-decoration-none fw-bold p-0 text-14">
                            {t("view")}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

        </div>
      </div>
    );
  }
}